<template>
	<footer class="footer">
		<div class="container">
			<div class="content has-text-centered">
				<p>💻 with 💚 by @jasba24</p>
			</div>
		</div>
	</footer>
</template>
